/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import { Column } from "../../../../common/commonComponents/lotDetailsTable";
import { ContainerForSterialization } from "../emptySterilization.types";

export const getColumnsForContainerSterilization = (t: any): Column[] => [
	{
		header: t("postAutoclaveProcess.emptySterilization.columns.plateId"),
		key: "plateId",
		className: "!px-8 !py-6",
		render: (row: ContainerForSterialization) => (
			<>
				<span className="text-sm font-black text-slate-700">
					{row.container_serial_number}
				</span>
			</>
		),
	},
	{
		header: t("postAutoclaveProcess.emptySterilization.columns.type"),
		key: "plateId",
		className: "!px-8 !py-6",
		render: (row: ContainerForSterialization) => (
			<>
				<span className="text-xs font-medium text-slate-500">
					{row.container_type}
				</span>
			</>
		),
	},
	{
		header: t("postAutoclaveProcess.emptySterilization.columns.status"),
		key: "plateId",
		className: "!px-8 !py-6",
		render: (row: ContainerForSterialization) => (
			<>
				<div className="flex flex-col gap-1">
					<span className="text-[10px] font-black text-emerald-600 uppercase tracking-widest flex items-center gap-1">
						<span className="material-symbols-outlined text-xs">
							verified
						</span>
						{row.container_status}
					</span>
				</div>
			</>
		),
	},
];
